<mat-form-field appearance="outline" class="w-100" color="primary" subscriptSizing="dynamic">
    <mat-label>{{ title }}</mat-label>
    <input [disabled]="disabled" [formControl]="memorySearchControl"
           [matAutocomplete]="auto"
           [placeholder]="placeholder" [readonly]="disabled" matInput>

    <mat-autocomplete #auto="matAutocomplete"
                      (optionSelected)='selectMemoryId($event.option.value.id)'
                      [displayWith]="displayFn">
        @for (memory of filteredMemories; track memory.id) {
            <mat-option [value]="memory">
                {{ memory.title }} ({{ memory.date | date : "dd/MM/yy" }})
            </mat-option>
        }
    </mat-autocomplete>
    @if (memorySearchControl?.value?.id && !disabled) {
        <button (click)="this.memorySearchControl.setValue(null); this.memorySelect.emit(undefined);"
                aria-label="Clear Search" mat-icon-button
                matSuffix>
            <mat-icon>close</mat-icon>
        </button>
    } @else if (this.showSearchBtn) {
        <button (click)="searchAllMemories()" (keyup.enter)="searchAllMemories()"
                aria-label="Search"
                mat-icon-button matSuffix matTooltip="Search Memories">
            <mat-icon color="primary">
                search
            </mat-icon>
        </button>
    }
    @if (loading) {
        <mat-icon matSuffix>
            <mat-spinner color="primary"></mat-spinner>
        </mat-icon>
    }
</mat-form-field>
